import {h, Fragment} from "preact"
import { RangeSlider, useRangeSlider, useCurrencyFormatting } from "@nosto/preact"
import { useState, useRef, useEffect, useMemo } from "preact/hooks"
import RangeInput from "./elements/RangeInput"
import Icon from "./elements/Icon"

export default function RangeFacet({ facet }) {
    const { min, max, range, updateRange } = useRangeSlider(facet.id)
    const { format } = useCurrencyFormatting()
    const isSelected = min !== range[0] || max !== range[1]
    const [active, setActive] = useState(isSelected)
    const contentRef = useRef(null);
    const [ height, setHeight ] = useState(0);
    const isPrice = useMemo(() => facet.name === "Price", []);

    useEffect(() => {
        setHeight(active ? contentRef.current?.scrollHeight : 0)
    }, [ active ])

    const toggleActive = () => {
        setActive(prevActive => !prevActive)
    }

    return (min !== max && (
        <li class="ns-facet-dropdown ns-range-facet">
            <button 
                type="button"
                class="ns-facet-toggle ns-flex ns-items-center ns-justify-between ns-anchor ns-lg-hidden ns-w-100 ns-border-box"
                data-nosto-element="facet"
                onClick={toggleActive}
                aria-controls={`${facet.id}-sub-menu`}
                aria-label={`${active ? 'Collapse' : 'Expand' } ${facet.name} filters`}
                aria-expanded={!!active}
            >
                <span class="ns-facet-toggle-text">{facet.name}</span>
                <svg aria-hidden="true" focusable="false" role="presentation" width="8" height="15" viewBox="0 0 8 15" fill="none" xmlns="http://www.w3.org/2000/svg">
                    <path d="M1 1L6.57143 7.5L1 14" stroke="black" stroke-linecap="round" stroke-linejoin="round"/>
                </svg>
            </button>
            <h3 class="ns-facet-title ns-hidden ns-lg-block">{facet.name}</h3>
            <div 
                class="ns-facet-body" 
                id={`${facet.id}-sub-menu`}
                aria-hidden={!active}
                ref={contentRef}
                style={{ height: `${height}px` }}
            >
                <div class="ns-range-slider-wrap">
                    <RangeSlider id={facet.id} />
                </div>
                <div class="ns-range-facet-body ns-flex ns-justify-between">
                    <div>{isPrice ? format(range[0]) : range[0]}</div>
                    {/* <div class="ns-range-facet-input-wrap ns-flex ns-flex-col">
                        <label for={`ns-${facet.id}-min`} class="ns-form-label">
                            Min.
                        </label>
                        <RangeInput
                            id={`ns-${facet.id}-min`}
                            min={min}
                            max={max}
                            range={range}
                            value={range[0]}
                            onChange={e => {
                                const value = parseFloat(e.currentTarget.value) || undefined
                                updateRange([value, range[1]])
                            }}
                        />
                    </div> */}
                    <div>{isPrice ? format(range[1]) : range[0]}</div>
                    {/* <div class="ns-range-facet-input-wrap ns-flex ns-flex-col">
                        <label for={`ns-${facet.id}-max`} class="ns-form-label">
                            Max.
                        </label>
                        <RangeInput
                            id={`ns-${facet.id}-max`}
                            min={min}
                            max={max}
                            range={range}
                            value={range[1]}
                            onChange={e => {
                                const value = parseFloat(e.currentTarget.value) || undefined
                                updateRange([range[0], value])
                            }}
                        />
                    </div> */}
                </div>
            </div>
        </li>
    ))
}
